import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import CaseListSection from './components/CaseListSection';
import ProcessSection from './components/ProcessSection';
import PricingSection from './components/PricingSection';
import CTASection from './components/CTASection';
import { SEO } from '../../utils/seo';

export default function MAListPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'M&A案件一覧',
    description: '実際に事業を行っている稼働法人の譲渡案件を多数掲載。後継者不在、事業の選択と集中、ハッピーリタイアなど様々な理由での譲渡案件をご紹介。',
    url: `${siteUrl}/ma-list`
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="M&A案件一覧 | 稼働法人の譲渡案件 | 株式会社G11"
        description="実際に事業を行っている稼働法人の譲渡案件を多数掲載。後継者不在、事業の選択と集中、ハッピーリタイアなど様々な理由での譲渡案件をご紹介。中小企業のM&A・事業承継をサポートします。"
        keywords="M&A案件,稼働法人,事業譲渡,会社売却,企業買収,事業承継,後継者不在"
        jsonLd={jsonLd}
      />
      <Navbar />
      <HeroSection />
      <CaseListSection />
      <ProcessSection />
      <PricingSection />
      <CTASection />
      <Footer />
    </div>
  );
}
